import { Heading2 } from 'components/shared/Typography.styled';
import styled from 'styled-components';
import { color, container, fontSize, spacing } from 'theme';

export const ShareTitle = styled.button`
  color: ${color('midnight_300')};
  background-color: transparent;
  border: none;
  appearance: none;
  padding: 0;
  cursor: pointer;
  font-size: ${fontSize('xl')};
  display: none;
  width: calc(${spacing('xl')} + ${spacing('xs')});
  margin-left: calc(-${spacing('xl')} - ${spacing('xs')});
  padding-right: ${spacing('xs')};

  &:hover {
    color: ${color('midnight_400')};
  }
`;

export const StyledContainer = styled.div`
  max-width: ${container('xl')};
  margin: ${spacing('xl4')} auto;
  text-align: left;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  gap: ${spacing('xl')};
  padding-left: ${spacing('md')};
  padding-right: ${spacing('md')};

  ${Heading2} {
    > span {
      display: flex;
      align-items: center;
    }
    &:hover ${ShareTitle} {
      display: block;
    }
  }
`;

export const StyledDesc = styled.p`
  font-size: ${fontSize('md')};
  line-height: 1.5;
  margin-top: 0;

  &.isTop {
    margin-top: -${spacing('md')};
    margin-bottom: 0;
  }
`;

export const StyledActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${spacing('md')};
`;
